import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const UserAuditSubRequestsModel = types
  .model('UserAuditSubRequestsModel', {
    data: types.maybeNull(types.frozen())
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.GET_USER_AUDIT_SUB_TYPE_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response);
      Framework.getEventManager().publish(constants.GET_USER_AUDIT_SUB_DATA_RESPONSE);
    },
    resetStoreValues() {
      const initialState = {
        data: {}
      };
      applySnapshot(self, initialState);
      Framework.getEventManager().publish(constants.GET_USER_AUDIT_SUB_DATA_RESPONSE);
    }
  }));

export default UserAuditSubRequestsModel;
